import { Button } from '@slal/ui/buttons';
import { PencilIcon } from '@slal/ui/icons';
import { Modal, ModalBody, ModalFooter } from '@slal/ui/modal';
import { P } from '@slal/ui/typography';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { ReviewEditModalProps } from './types';

export const ReviewEditWarningModal = ({ pathname, ...otherProps }: ReviewEditModalProps) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);
    const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);

    return (
        <>
            <Button startIcon={<PencilIcon />} color="secondary" variant="outline" onClick={openModal}>
                Change
            </Button>
            <Modal isOpen={isModalOpen} onClose={closeModal} {...otherProps}>
                <ModalBody>
                    <P>
                        We'll take you back so you can make changes. You'll then need to complete the rest of your
                        application as some changes may affect your other choices.
                    </P>
                </ModalBody>
                <ModalFooter>
                    <Button role="link" variant="solid" color="secondary" onClick={() => navigate(pathname)}>
                        Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
